import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HeroBanner } from 'dw-contentful-components';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { RichText } from '../RichText';
import standardiseContentfulId from '../../util/standardiseContentfulId';

const props = {
  brand: PropTypes.string.isRequired,
  heroBanner: PropTypes.shape({
    contentfulId: PropTypes.string,
    contentTitle: PropTypes.object,
    contentText: PropTypes.object,
    image: PropTypes.object,
    showLogo: PropTypes.bool,
  }).isRequired,
};

const headingRichTextOptions = {
  renderMark: {
    [MARKS.BOLD]: (richText) => <strong>{richText}</strong>,
    [MARKS.ITALIC]: (richText) => <i>{richText}</i>,
    [MARKS.UNDERLINE]: (richText) => <u>{richText}</u>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <h2>{children}</h2>,
  },
};

const HeroBannerWrapper = ({ brand, heroBanner, variant = 2 }) => {
  const [headingOptions, setHeadingOptions] = useState({...headingRichTextOptions});
  const {
    contentfulId,
    contentTitle,
    contentText,
    image: mediaData,
    showLogo,
  } = heroBanner;

  // Override H1 if variant = 1 for reach text box
  // UXE-11082 SEO
  useEffect(() => {
    if (variant == 1) {
      const renderNode = {
        [BLOCKS.PARAGRAPH]: (node, children) => <h1>{children}</h1>,
      }
      setHeadingOptions({ ...headingRichTextOptions, renderNode });
    } else {

      setHeadingOptions({ ...headingRichTextOptions });
    }
  }, [variant])

  const heroTitle = (
    <RichText content={contentTitle} options={headingOptions} />
  );
  const heroText = <RichText content={contentText} />;

  const {
    accessibilityText: alt,
    asset: { fluid },
  } = mediaData;

  return (
    <div
      data-testid="hero-banner-wrapper"
      id={standardiseContentfulId(contentfulId)}
    >
      <HeroBanner
        brand={brand}
        bannerTitle={heroTitle}
        bannerText={heroText}
        imageAlt={alt}
        imageFluid={fluid}
        variant={2}
        showLogo={showLogo}
      />
    </div>
  );
};

HeroBannerWrapper.propTypes = props;

export { HeroBannerWrapper };
